global.fn = global.jQuery = global.$ = require("jquery");
import WOW from "wow.js";
new WOW().init({
  animateClass: "animated",
});

// import AutoNumeric from "autonumeric";
if ($("[data-autonumeric]").length) {
  const lang = $("html")[0].lang;
  const autoNumericOptions = {
    digitGroupSeparator: ".",
    decimalCharacter: ",",
    decimalCharacterAlternative: ".",
    decimalPlaces: "0",
  };
  if (lang === "en-US") {
    autoNumericOptions.digitGroupSeparator = ",";
    autoNumericOptions.decimalCharacter = ".";
    autoNumericOptions.decimalCharacterAlternative = ".";
  }
  new AutoNumeric.multiple("[data-autonumeric]", autoNumericOptions);
}

import Sharect from "./sharect.js";

if ($("[data-allow-sharect]").length) {
  Sharect.config({
    facebook: false,
    twitter: false,
    backgroundColor: "#b74c27",
    selectableElements: ["*"],
  })
    .appendCustomShareButtons([
      {
        icon: `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2590_19455)">
          <path d="M16.3533 14.9995H18.2937L18.5871 12.529H16.4111V11.3522C16.4111 10.7647 16.4698 10.4115 17.3518 10.4115H18.5286V8H16.5882C14.2945 8 13.4709 9.17684 13.4709 11.1173V12.5882H12V14.9995H13.4718V22H16.3533V14.9995Z" fill="white"/>
        </g>
        <defs>
          <clipPath id="clip0_2590_19455">
            <rect width="30" height="30" fill="white"/>
          </clipPath>
        </defs>
      </svg>`,
        url: "https://www.facebook.com/sharer/sharer.php?u=PAGE_URL%20TEXT_SELECTION",
      },
      {
        icon: `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2590_19458)">
          <path d="M10.877 21H8.32943V12.8479H10.877V21ZM9.53793 11.8281H9.51958C8.59775 11.8281 8 11.205 8 10.4155C8 9.61043 8.61572 9 9.5559 9C10.4954 9 11.0735 9.60887 11.092 10.4133C11.092 11.203 10.4954 11.8281 9.53793 11.8281ZM21.0686 21H18.1801V16.7814C18.1801 15.6772 17.7287 14.9238 16.7348 14.9238C15.9747 14.9238 15.5526 15.4322 15.3556 15.9226C15.2821 16.0981 15.2933 16.3432 15.2933 16.5889V21H12.4318C12.4318 21 12.469 13.5273 12.4318 12.8479H15.2933V14.1273C15.4625 13.5679 16.3765 12.7695 17.8364 12.7695C19.6463 12.7695 21.0686 13.9423 21.0686 16.4669V21Z" fill="white"/>
        </g>
        <defs>
          <clipPath id="clip0_2590_19458">
            <rect width="30" height="30" fill="white"/>
          </clipPath>
        </defs>
      </svg>`,
        url: "https://www.linkedin.com/sharing/share-offsite/?url=PAGE_URL%20TEXT_SELECTION",
      },
    ])
    .init();
}

if (navigator.appVersion.indexOf("Win") != -1) {
  $("body").addClass("win-os");
}

import "./components/header";
import "./components/video-ele";
import "./components/slider";
import "./components/popup";

import "./components/dropdown";
import "./components/tabs";
import "./components/form";
import "./components/clients";
import "./components/about";
import "./components/counted-sections";
import "./components/hover";
import "./components/triangle";
import "./components/smart-suggestions";
import "./components/social-share";
import "./components/supports";
import "./components/animation-widget";
import "./components/newsletter";
import "./components/related-insight";
import "./components/scrolling-progress";
import "./components/insight-details";
import "./components/copy-clipboard";
import "./components/est-labor-cost";
import "./components/magnific-gallery";
import "./components/executive-team";
import "./components/partners";
import "./components/success-stories";
import "./components/histories";
import "./components/wp-support";
import "./components/countdown";
import "./components/shortDes";
import "./components/cookie";
import "./components/moengage-tracking";
import "./components/cart-popup";
import "./components/idle.js";
import "./components/paging.js";
import "./components/event-details.js";
import "./components/office.js";
import "./components/slick.js";
import "./components/iframe-resize";
import "./components/button-align";
import "./components/loop";
import "./components/aichatbox.js";
import "./components/aside-contact";
